// pipe (info tips): the "help tips on/off" switch in the workbench top bar — chrome rendered
// above every ERP screen on desktop AND mobile web (the sidebar hides behind the hamburger on
// phones, so the labeled sidebar twin alone would not be reachable everywhere). Mounted PER
// VIEW and self-gated by that view's OWN pathname, so in an Electron split each ERP view
// carries its toggle and doc/canvas views keep their chrome untouched (state stays in
// lockstep via the shared module-level store).
import { IconButton, Tooltip } from '@affine/component';
import {
  erpInfoTips$,
  setInfoTips,
} from '@affine/core/modules/erp/erp-info-tips';
import { isErpPath } from '@affine/core/modules/erp/erp-routes';
import { useI18n } from '@affine/i18n';
import {
  InformationFillDuotoneIcon,
  InformationIcon,
} from '@blocksuite/icons/rc';
import { useLiveData, useService } from '@toeverything/infra';
import { useCallback } from 'react';

import { ViewService } from '../../modules/workbench/services/view';

export const InfoTipsHeaderToggle = () => {
  const t = useI18n();
  const on = useLiveData(erpInfoTips$);
  const view = useService(ViewService).view;
  const location = useLiveData(view.location$);
  const toggle = useCallback(() => setInfoTips(!erpInfoTips$.value), []);

  if (!isErpPath(location.pathname)) {
    return null;
  }

  const hint = on
    ? t['com.affine.pipe.tooltip.toggle.hint-off']()
    : t['com.affine.pipe.tooltip.toggle.hint-on']();

  return (
    <Tooltip content={hint}>
      <IconButton
        size="24"
        onClick={toggle}
        aria-pressed={on}
        aria-label={hint}
        data-testid="pipe-info-tips-header-toggle"
      >
        {on ? <InformationFillDuotoneIcon /> : <InformationIcon />}
      </IconButton>
    </Tooltip>
  );
};
